<template>
  <div class="main">
    <Navbar />
    <section class="main-hero">
      <p class="main-title">{{ title }}</p>
      <p class="main-subtitle" v-if="subtitle">{{ subtitle }}</p>
      <p v-if="storefrontUrl" class="storefront">
        <a :href="storefrontUrl" target="_blank" rel="noopener noreferrer"
          >Get access on Whop</a
        >
      </p>
      <router-link
        v-if="showRetry"
        :to="{ name: 'LoginWhop' }"
        class="alt-link"
        >Try again</router-link
      >
    </section>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import WhopAuthService from "@/services/WhopAuthService";
import * as fb from "@/firebase";

export default {
  name: "LoginWhopCallback",
  components: { Navbar },
  data() {
    return {
      title: "Signing you in…",
      subtitle: "",
      storefrontUrl: "",
      showRetry: false,
      handled: false,
    };
  },
  async mounted() {
    if (this.handled) return;
    this.handled = true;
    await this.complete();
  },
  methods: {
    fail(message) {
      this.title = "Unable to sign in";
      this.subtitle = message;
      this.showRetry = true;
    },
    async complete() {
      const params = new URLSearchParams(window.location.search);
      const error = params.get("error");
      const code = params.get("code");
      const state = params.get("state");

      if (window.history.replaceState) {
        window.history.replaceState({}, document.title, "/login/whop/callback");
      }

      if (error) {
        this.fail("Sign-in was cancelled or denied.");
        return;
      }

      if (!code || !state) {
        this.fail("Invalid sign-in response. Please try again.");
        return;
      }

      try {
        const res = await WhopAuthService.completeWhopLogin(code, state);
        if (!res?.success || !res?.data?.customToken) {
          this.storefrontUrl = res?.data?.storefrontUrl || "";
          this.fail(
            res?.error ||
              "You do not have an active membership. Purchase access on Whop, then try again."
          );
          return;
        }

        const { user } = await fb.auth.signInWithCustomToken(
          res.data.customToken
        );
        await user.getIdToken(true);
        await this.$store.dispatch("fetchUserProfile", user);
        await this.$router.replace({ name: "EducationPDFLessons" });
      } catch (e) {
        const status = e?.response?.status;
        const data = e?.response?.data;
        this.storefrontUrl = data?.data?.storefrontUrl || "";
        if (status === 403 && data?.error) {
          this.fail(data.error);
        } else if (status === 429) {
          this.fail("Too many attempts. Please wait a moment and try again.");
        } else {
          this.fail("Unable to complete sign-in. Please try again.");
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
  font-family: "Work Sans", sans-serif;
  background: linear-gradient(
    180deg,
    var(--background-color-gradient-secondary) 0%,
    var(--background-color-gradient-tertiary) 100%
  );
}
.main-hero {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  .main-title {
    font-family: "Work Sans";
    font-weight: 300;
    font-size: 28px;
    text-align: center;
    color: white;
    margin-bottom: 12px;
  }
  .main-subtitle {
    font-weight: 300;
    font-size: 14px;
    text-align: center;
    color: #e5e5e5;
    max-width: 420px;
  }
}
.storefront,
.alt-link {
  margin-top: 16px;
  color: #ffffff;
  text-decoration: underline;
  font-size: 13px;
}
</style>
